var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M20.2 18H5.8C4.80586 18 4 18 4 16.2857V15.5714C4 13 5.8 13 7.6 13H18.4C20.2 13 22 13 22 15.5714V16.2857C22 18 21.194 18 20.2 18Z",
    fill: "#353E50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7175 18H3.71753C2.61293 18 1.71753 18 1.71753 16V14C1.71753 11 3.71753 11 5.71753 11H17.7175C19.7175 11 21.7175 11 21.7175 14V16C21.7175 18 20.822 18 19.7175 18Z",
    stroke: "#353E50",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2176 11H3.21756V6.00003C3.15935 5.59251 3.19682 5.17704 3.32701 4.78652C3.45719 4.39599 3.6765 4.04114 3.96758 3.75005C4.25867 3.45897 4.61352 3.23966 5.00405 3.10948C5.39457 2.9793 5.81004 2.94182 6.21756 3.00003H17.2176C17.6251 2.94182 18.0405 2.9793 18.4311 3.10948C18.8216 3.23966 19.1765 3.45897 19.4675 3.75005C19.7586 4.04114 19.9779 4.39599 20.1081 4.78652C20.2383 5.17704 20.2758 5.59251 20.2176 6.00003V11Z",
    stroke: "#353E50",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71753 7H10.7175C10.9827 7 11.2371 7.10536 11.4246 7.29289C11.6122 7.48043 11.7175 7.73478 11.7175 8V11H5.71753V8C5.71753 7.73478 5.82289 7.48043 6.01042 7.29289C6.19796 7.10536 6.45231 7 6.71753 7Z",
    stroke: "#353E50",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.71753 18V21",
    stroke: "#353E50",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7175 18V21",
    stroke: "#353E50",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7175 7H16.7175C16.9827 7 17.2371 7.10536 17.4246 7.29289C17.6122 7.48043 17.7175 7.73478 17.7175 8V11H11.7175V8C11.7175 7.86868 11.7434 7.73864 11.7936 7.61732C11.8439 7.49599 11.9176 7.38575 12.0104 7.29289C12.1033 7.20003 12.2135 7.12638 12.3348 7.07612C12.4562 7.02587 12.5862 7 12.7175 7Z",
    stroke: "#353E50",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBed);
export default __webpack_public_path__ + "static/media/bed.283c30f9faafe8541fc5875487d49807.svg";
export { ForwardRef as ReactComponent };